import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
const BOOKMARKS_KEY = '/rest/collections/list_bookmarks';
export const useRefetchBookmarks = () => {
    const queryClient = useQueryClient();
    return useCallback(() => {
        queryClient.invalidateQueries({
            queryKey: QueryClientHelper.makeQueryKey(BOOKMARKS_KEY),
        });
    }, [queryClient]);
};
//# sourceMappingURL=useBookmarksQuery.js.map